export const CLangsAllowed = {
    ENGLISH: 'en',
    SPANISH: 'es'
}